import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import AuditSessionsMobile from "../mobile/audit/AuditSessionsMobile";
import AuditSessions from "./AuditSessions";
export default function ResponsiveAuditSessions(props) { return useIsMobile() ? <AuditSessionsMobile {...props} /> : <AuditSessions {...props} />; }
